<div class="modal-header">
  <div class="row">
    <div class="col">
      <h4 class="main-title text-start mb-0">
        {{ cancelCmsCopy.cancelFlightCopy }}
      </h4>
    </div>
  </div>
</div>
<div class="modal-body">
  <p>
    {{ cancelCmsCopy.cancelConfirmCopy }}
  </p>
</div>
<div class="modal-footer">
  <button
    class="btn btn-outline-primary"
    (click)="cancel()"
    data-qa="tripCancel-cancel-button"
  >
    {{ cancelCmsCopy.cancelCopy }}
  </button>
  <button
    class="btn btn-primary"
    (click)="continue()"
    data-qa="tripCancel-return-button"
  >
    {{ cancelCmsCopy.continueCopy }}
  </button>
</div>
